import { Component, inject, Input, ViewEncapsulation } from '@angular/core';
import { WebhookFormComponent } from '@components/webhook-form/webhook-form.component';
import { Account } from '@models/account';
import { Webhook, Webhooks } from '@models/webhook';
import { OverlayService } from '@services/overlay';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { IconDirective } from '../../directives/icon.directive';

@Component({
  selector: 'lv-webhooks',
  templateUrl: 'webhooks.component.html',
  styleUrls: ['webhooks.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, TranslateModule, IconDirective]
})
export class WebhooksComponent {
  private overlayService = inject(OverlayService);
  private webhookService = inject(Webhooks);

  @Input() account: Account;

  edit(webhook: Webhook) {
    this.overlayService.open(WebhookFormComponent, { webhook: webhook });
  }

  destroy(webhook: Webhook) {
    this.webhookService.$destroy(webhook).then(() => this.account.webhooks.$removeResource(webhook));
  }

  newWebhook() {
    const webhook = this.account.webhooks.$build({ event: 'pass_fail', accountId: this.account.id });
    this.overlayService.open(WebhookFormComponent, { webhook: webhook });
  }
}
